import React from 'react'
import Text from '../../components/text/Text'

interface IProps {
    groupFilter: string
    groupChips: {group: string; count: number}[]
    totalGroups: number
    onSelect: (group: string) => void
}

/** 그룹 필터 (거래소/토큰) 칩 — Competition·Rolling 공통 그룹 기준 + 전체 그룹에서의 안내 문구 */
const GroupFilter: React.FC<IProps> = ({groupFilter, groupChips, totalGroups, onSelect}) => {
    return (
        <>
            {/* 그룹 필터 (거래소/토큰) — 많아지면 여러 줄 + 스크롤 */}
            <div className="mt-[14px] flex items-center gap-x-[10px] flex-wrap gap-y-[10px] max-h-[132px] overflow-y-auto">
                <div
                    onClick={() => onSelect('all')}
                    className={`px-[14px] py-[6px] border rounded-full cursor-pointer ${
                        groupFilter === 'all' ? 'bg-font01 border-font01' : 'bg-white border-line02 hover:border-font01'
                    }`}>
                    <Text className={`text-ti3 ${groupFilter === 'all' ? 'text-white' : 'text-font02'}`}>
                        전체 그룹 ({totalGroups})
                    </Text>
                </div>
                {groupChips.map(g => {
                    const selected = groupFilter === g.group
                    return (
                        <div
                            key={g.group}
                            onClick={() => onSelect(g.group)}
                            className={`px-[14px] py-[6px] border rounded-full cursor-pointer ${
                                selected ? 'bg-font01 border-font01' : 'bg-white border-line02 hover:border-font01'
                            }`}>
                            <Text className={`text-ti3 ${selected ? 'text-white' : 'text-font02'}`}>
                                {g.group} ({g.count})
                            </Text>
                        </div>
                    )
                })}
            </div>

            {groupFilter === 'all' && (
                <Text className="text-body3 text-font03 mt-[10px]">
                    그룹을 누르면 해당 그룹의 리그 목록으로 들어갑니다. 전체 상태 + 전체 그룹에서는 핸들(≡)을 드래그해 표시
                    순서(sort_value)를 그룹 단위로 통일·자동 저장할 수 있어요. (위일수록 먼저 노출)
                </Text>
            )}
        </>
    )
}

export default GroupFilter
